export default __webpack_public_path__ + "static/media/merchant-id.9af014d1.png";